import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  fullPage?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ size = 'medium', fullPage = true }) => {
  const dimensions = {
    small: 24,
    medium: 36,
    large: 48,
  };

  const d = dimensions[size];

  return (
    <div className={`loader-container ${fullPage ? 'loader-fullpage' : ''}`}>
      <svg
        className="loader-spinner"
        width={d}
        height={d}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="loader-circle"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
